export default {
  letter: 0,
  parcel: 1,
};
